<template>
<v-container fluid>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline">海外請求書</div>
      </div>
    </v-card-title>
    <v-card-actions>
      <!-- <v-btn @click="test">test</v-btn> -->
      <v-btn v-permit.OVERSEAS_REQUEST_SEARCH @click="search" class="btn-search">{{$t('app.buttons.search')}}</v-btn>
      <v-btn v-permit.OVERSEAS_REQUEST_CONFIRM :disabled="selected.length !== 1" @click="openOutput">確認</v-btn>
      <v-btn v-permit.OVERSEAS_REQUEST_ISSUE :disabled="selected.length !== 1 || !canFirstPrint || !hasConfirmed" @click="downloadOutPut">発行</v-btn>
      <v-btn v-permit.OVERSEAS_REQUEST_REISSUE :disabled="selected.length !== 1 || !canRepeatPrint" @click="downloadOutPut">再発行</v-btn>
      <!-- <v-btn :disabled="selected.length == 0 || selected.length > 1" @click="download">資料ダウンロード</v-btn> -->
    </v-card-actions>
  </v-card>
  <v-card>
    <v-form>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex md3 sm6 xs12>
            <v-layout row wrap>
              <v-flex md6 pr-2>
                <date-picker label="納入日" v-model="query.forecastDeliveryDateFrom"></date-picker>
              </v-flex>
              <v-flex md6 pl-2>
                <date-picker :min="query.forecastDeliveryDateFrom" label="~" v-model="query.forecastDeliveryDateTo"></date-picker>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md3 sm6 xs12>
            <remote-autocomplete :label="$t('app.labels.partner')" url="companies/kvt?type=PARTNER" v-model="query.partnerId" />
          </v-flex>
          <v-flex md3 sm6 xs12>
            <v-text-field clearable label="海外請求書番号" v-model="query.no" />
          </v-flex>
          <v-flex md3 sm6 xs12>
            <remote-autocomplete :label="$t('app.labels.bu.name')" url="divisions/kv?type=BU" v-model="query.buId" />
          </v-flex>
          <v-flex md3 sm6 xs12>
            <v-text-field label="D/O NO" v-model="query.doNo" />
          </v-flex>
          <v-flex md3 sm6 xs12>
            <v-text-field label="B/L NO" v-model="query.blNo" />
          </v-flex>
          <v-flex md3 sm6 xs12>
            <v-checkbox label="未印刷" v-model="query.isPrinted"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
  <v-card class="mt-2">
    <v-data-table :headers="headers" :items="results" :loading="loading" :pagination.sync="pagination" :rows-per-page-items="[10]" :total-items="pagination.totalItems" class="inline-edit" item-key="id" select-all v-model="selected">
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
        </td>
        <!-- <td>{{ props.item.no }}</td> -->
        <td>{{ props.item.overseasRequestSeq }}</td>
        <td>{{ props.item.doNo }}</td>
        <td>{{ props.item.partnerName }}</td>
        <td>{{ props.item.blNo }}</td>
        <td>{{ props.item.forecastDeliveryDate }}</td>
        <td>{{ props.item.buCode + ":" + props.item.buName }}</td>
        <td>{{ props.item.expectedCollectionDate }}</td>
        <td>
          <v-icon v-if="props.item.sjlDownload">check</v-icon>
          <v-icon v-if="!props.item.sjlDownload">clear</v-icon>
        </td>
        <td>
          <v-icon v-if="props.item.confirmed">check</v-icon>
          <v-icon v-if="!props.item.confirmed">clear</v-icon>
        </td>
        <td>
          <v-icon v-if="props.item.issuePrinted">check</v-icon>
          <v-icon v-if="!props.item.issuePrinted || props.item.issuePrinted==false">clear</v-icon>
        </td>
        <td>
          <v-icon @click="showPrintHistory(props.item.id)">history</v-icon>
        </td>
      </template>
    </v-data-table>
  </v-card>
  <print-history-dialog :history="historyData" ref="print"></print-history-dialog>
  <out @reload="load" ref="out" />
</v-container>
</template>

<script>
/* eslint-disable no-console */
import PrintHistoryDialog from '../B2100/PrintHistoryDialog'
import Out from './Out'

export default {
  components: {
    PrintHistoryDialog,
    Out,
  },
  methods: {
    test() {
      this.$download(`/delivery-orders/pdfs/${this.selected[0].id}`)
    },
    openOutput() {
      this.$refs.out.popup(this.selected[0], 'CONFIRM')
    },
    downloadOutPut() {
      this.$refs.out.popup(this.selected[0], 'ISSUE')
    },
    download() {
      this.$refs.DownloadDocDialog.popup()
    },
    showPrintHistory(id) {
      this.$http.get(`/overseas-requests/histories/${id}`).then((res) => {
        this.historyData = res.data
        this.$refs.print.popup()
      })
    },
    load() {
      this.selected = []
      this.autoload = true
      return this.$http
        .get('/overseas-requests', {
          params: {
            ...this.query,
            ...this.$pageable(),
          },
        })
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    search() {
      this.$storeParams()
      this.pagination.page = 0
      this.load()
    },

    print() {
      this.$http
        .get(`/eiajs/${this.selected[0].id}/orders`)
        .then((res) => {
          this.$refs.eiajDlg.popup(res.data, this.selected[0].id)
        })
        .catch(() => {
          this.$message('', 'get eiaj failed')
        })
      // let pages = this.selected.map(s => ({
      //   ...s,
      //   cartonNo: this.containerNo(s)
      // }))
    },
    reportTotal() {
      this.$refs.docTotalDlg.popup([this.shipment])
    },
  },
  data() {
    return {
      results: [],
      loading: false,
      query: {
        isPrinted: false,
      },
      selected: [],
      dialog: {
        show: false,
      },
      historyData: [],
      pagination: {
        page: 1,
      },
      headers: [{
          text: '請求書番号',
          value: '',
          sortable: false
        },
        {
          text: 'D/O NO',
          value: '',
          sortable: false
        },
        {
          text: '海外取引先',
          value: '',
          sortable: false
        },
        {
          text: 'B/L NO',
          value: '',
          sortable: false
        },
        {
          text: '納入日',
          value: '',
          sortable: false
        },
        {
          text: '事業本部',
          value: '',
          sortable: false
        },
        {
          text: '回収予定日',
          value: '',
          sortable: false
        },
        {
          text: 'SJL控え',
          value: '',
          sortable: false
        },
        {
          text: '確認状態',
          value: '',
          sortable: false
        },
        {
          text: '印刷済',
          value: '',
          sortable: false
        },
        {
          text: '印刷履歴',
          value: '',
          sortable: false
        },
      ],
    }
  },
  mounted() {
    this.$loadParams()
  },
  computed: {
    hasConfirmed() {
      return this.selected.filter((s) => !s.confirmed).length === 0
    },
    canFirstPrint() {
      return this.selected.filter((s) => !s.issuePrinted).length > 0
    },
    canRepeatPrint() {
      return this.selected.filter((s) => s.issuePrinted).length > 0
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
